import {PlaybookIssueOverride} from "common/types/issue";

export const issueOverrideFields: PlaybookIssueOverride[] = [
  {field: "standard_language", label: "Standard Language"},
  {field: "description", label: "Report Description"},
  {field: "guidance", label: "Guidance"},
  {field: "required_change", label: "Required Change"},
  {field: "fallback_guidance", label: "Fallback & Escalation"},
] as const;
